export default __webpack_public_path__ + "e13e68d2590814d3e691e489c3a80483.svg";